import React, { useContext, useMemo } from 'react'
import { Layout, Button, Typography, Divider } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import UserPanel from '../../user-panel/userPanel'
import styles from './Header.module.scss'
import AnkoPhLogo_White from '../../../assets/images/AnkoPhLogo_White.png'
import { StoreContext } from '../../../context/storeContext'
import { UserContext } from '../../../context/userContext'

const { Header: AntHeader } = Layout
const { Text } = Typography

export default function Header({ toggleMenu }) {
  const storeInfo = useContext(StoreContext)
  const { userRole, isLoadingAccess } = useContext(UserContext)

  const primaryRole = userRole || null

  // Get the store name directly from StoreContext (which now reads from localStorage and maps properly)
  const displayStoreName = useMemo(() => {
    // StoreContext now handles both Cognito and AD users properly
    // It reads from localStorage and maps store IDs to names
    return storeInfo?.name || ''
  }, [storeInfo?.name])

  // Get environment indicator (DEV or PROD)
  const environment = process.env.REACT_APP_ENV?.toUpperCase() === 'PROD' ? 'PROD' : 'DEV'


  return (
    <AntHeader className={styles.headerComponent}>
      <div className={styles.headerToolbar}>
        <div className={styles.leftSection}>
          <Button
            icon={<MenuOutlined style={{ color: '#fff' }} />}
            type="text"
            className={styles.menuButton}
            onClick={toggleMenu}
          />
          <img
            src={AnkoPhLogo_White}
            height={30}
            loading="lazy"
            alt="AnkoPh-logo"
            className={styles.logo}
          />
        </div>

        {/* Right section with store name and user panel */}
        <div className={styles.rightSection}>
          {/* Store name - visible only in desktop */}
          {displayStoreName && (
            <>
              <div className={styles.storeNameContainer}>
                <Text className={styles.storeName}>
                  {environment === 'DEV' && (
                    <>
                      {environment}
                      <Divider type="vertical" className={styles.divider} style={{ margin: '0 12px' }} />
                    </>
                  )}
                  {displayStoreName}
                </Text>
              </div>
              <Divider type="vertical" className={styles.divider} />
            </>
          )}
          <UserPanel
            menuMode="context"
            userRole={primaryRole}
            isLoadingRole={isLoadingAccess}
          />
        </div>
      </div>
    </AntHeader>
  )
}